import classNames from "classnames";

import "./styles.scss";

const CustomGridContainer = ({
  children,
  className = "",
  style = {},
  justify = "flex-start",
  alignItems = "stretch",
  direction = "row",
}) => {
  const containerStyle = {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: justify,
    alignItems,
    flexDirection: direction,
    ...style,
  };

  return (
    <div className={classNames("custom-box-grid-container", className)} style={containerStyle}>
      {children}
    </div>
  );
};

export default CustomGridContainer;
